/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Time_NightInputs */

const en_ui_time_night = /** @type {(inputs: Ui_Time_NightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Night`)
};

const de_ui_time_night = /** @type {(inputs: Ui_Time_NightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in der Nacht`)
};

/**
* | output |
* | --- |
* | "Night" |
*
* @param {Ui_Time_NightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_time_night = /** @type {((inputs?: Ui_Time_NightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Time_NightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_time_night(inputs)
	return de_ui_time_night(inputs)
});